// Шрифт Inter (оффлайн, self-hosted через @fontsource; включает latin + vietnamese).
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import '@vinprop/design-system/styles.css'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import './assets/tooltip.css'

import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { loadFeatures } from './config/features.config'

const app = createApp(App)

const pinia = createPinia()

// DEV-1283. Рантайм-флаги фич грузим ДО монтирования: иначе фича за выключенным
// флагом успеет мигнуть на экране и пропасть. loadFeatures никогда не бросает —
// при любой проблеме флаги пустые (fail-closed), приложение стартует как обычно.
// Первая навигация стартует уже в app.use(router), а ленивый компонент маршрута
// бывает выбран по флагу (канва ЖК) — навигация ждёт флаги до резолва
// компонентов. Запрос идёт параллельно с проверкой сессии. Auth — в роутере.
const featuresLoaded = loadFeatures()
router.beforeEach(() => featuresLoaded)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(FloatingVue, {
  themes: {
    tooltip: {
      delay: { show: 300, hide: 0 },
      instantMove: true,
      triggers: ['hover'],
    },
  },
})

// Durable-фикс «Failed to fetch dynamically imported module» после деплоя.
// Vite при каждом билде даёт чанкам новые content-hash имена и удаляет старые.
// Вкладка, открытая на прошлом билде, при ленивой навигации запрашивает уже
// удалённый чанк → 404. Один раз перезагружаем shell (index.html отдаётся
// no-store и подтянет актуальные ассеты). Защита от петли — не чаще раза в 10с,
// чтобы при реально битом деплое показать ошибку, а не зациклиться.
function reloadOnceForStaleChunk(): void {
  const KEY = '__chunk_reload_at'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (Date.now() - last < 10_000) return
  sessionStorage.setItem(KEY, String(Date.now()))
  window.location.reload()
}
window.addEventListener('vite:preloadError', reloadOnceForStaleChunk)
router.onError((err) => {
  if (
    /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(
      String(err),
    )
  ) {
    reloadOnceForStaleChunk()
  }
})

// DEV-2491. Монтируем, когда готов первый экран: до этого в #app крутится
// индикатор из index.html. Раньше mount сразу после флагов менял его на пустой
// RouterView, и пока первая навигация проверяла сессию, экран был белым.
Promise.allSettled([featuresLoaded, router.isReady()]).finally(() => app.mount('#app'))
